import styled from 'styled-components';

const RightBtn = styled.div`
  color: #737373;
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0.8;
  background: white;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
`;

export default RightBtn;
